import React from 'react'
import navigate from 'utils/navigate'
import { Button } from '@material-ui/core'

export const handleClick = ({ onClick, path }) => event => {
  onClick && onClick(event)
  path && navigate(path)
}

const MenuButton = ({ onClick, path, ...props }) => (
  <Button
    css={{
      whiteSpace: 'nowrap',
      marginLeft: 20,
    }}
    onClick={handleClick({ onClick, path })}
    {...props}
  />
)

export default MenuButton
